import {
  UNLOCKACCOUNT_SUCCESS,
  UNLOCKACCOUNT_FAILED,
  RESET_UNLOCKACCOUNT,
  LOADING_UNLOCKACCOUNT,
  NETWORK_ERROR_UNLOCKACCOUNT,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UNLOCKACCOUNT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UNLOCKACCOUNT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UNLOCKACCOUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UNLOCKACCOUNT:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UNLOCKACCOUNT:
      return (state = initialState);
    default:
      return state;
  }
};
